module.exports = __webpack_public_path__ + "static/media/pic1.5a1ba548.jpg";